import { lazy } from 'react';
import { Modal } from '@client/components/globals/Modal';
import { Loader } from '@client/components/common/Loader';
import type { LoginModalProps } from '@client/components/Main/common/LoginModalProps.interface';

const AddNameLoader = lazy(() => import('./AddName'));

export const openAddNameModal = (props?: LoginModalProps) => Modal.show({
  body: (
    <Loader
      load={AddNameLoader}
      {...props}
    />
  ),
  buttons: [],
});
